import { render, staticRenderFns } from "./PdfPage.vue?vue&type=template&id=21cd59d3&"
import script from "./PdfPage.vue?vue&type=script&lang=ts&"
export * from "./PdfPage.vue?vue&type=script&lang=ts&"
import style0 from "./PdfPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Intersect from 'vuetify/lib/directives/intersect'
installDirectives(component, {Intersect})
